import React from 'react';
import '../css/sort-dropdown.less';

const sortDropDown = ({ label="Sort by:", options, className = "sortby", onChange, children, value }) => {
    return (<div className={className}>
        {
            children ? children :
                <React.Fragment>
                    <span className={'label'}>{label}</span>
                     <select
                        aria-label="Sort"
                        className="sort-menu"
                        value={value}
                        onChange={onChange}
                    >
                        {options.map((sortType, i) => {
                            return (
                                <option 
                                    aria-label={sortType.label} 
                                    className='sort-option' key={i} value={sortType.value || i}>
                                    {sortType.label}
                                </option>
                            )
                        })}
                    </select>
                    <span className="sort-arrow-down hp-icon page-down"></span>
                </React.Fragment>
        }
    </div>)
}

export default sortDropDown;